import './Textarea.scss';

type Props = {
  value: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  className?: string;
  cols?: number;
  rows?: number;
};

const Textarea: React.FC<Props> = ({
  value = '',
  placeholder = '',
  onChange = () => {},
  name = '',
  className = 'textarea',
  cols = 80,
  rows = 10,
  ...rest
}) => {
  return (
    <textarea
      cols={cols}
      rows={rows}
      value={value}
      name={name}
      onChange={onChange}
      className={className}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default Textarea;
